import { APP_INIT } from 'FRONTEND/actions/constants';
import { pickExpert, updateHasPayment } from 'FRONTEND/reducers/bookingSlice';
import { goToGivenExpertForm } from 'FRONTEND/reducers/calendarSlice';
import {
  searchRequest,
  searchSuccess,
  searchError,
  check,
  unCheck,
  listSettings,
} from 'FRONTEND/reducers/expertSlice';
import { selectManagedExpertIds } from 'FRONTEND/selectors/expertSelectors';
import * as expert from 'FRONTEND/utils/backendApi/expert/expert';
import { MAX_CHECKED_EXPERT_COUNT } from 'FRONTEND/utils/constants';

const expertMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case APP_INIT: {
      next(action);
      store.dispatch(listSettings());
      return;
    }

    case searchRequest.toString(): {
      expert.getExperts({
        name: action.payload.name,
        tenantId: action.payload.tenantId,
        appointmentType: action.payload.appointmentType,
        startDate: action.payload.startDate,
        endDate: action.payload.endDate,
        hasPayment: action.payload.hasPayment,
      }).then((experts) => {
        if (action.payload.isManaged) {
          experts = experts.filter((expert) => selectManagedExpertIds(store.getState()).includes(expert.id));
        }
        store.dispatch(searchSuccess({ experts }));
      }).catch((error) => store.dispatch(searchError({ error: error.message })));
      return next(action);
    }

    case goToGivenExpertForm.toString(): {
      if (action.payload?.id) {
        // TODO: do not trigger action, only use reducer instead
        store.dispatch(pickExpert({ id: action.payload.id }));
      }
      return next(action);
    }

    case updateHasPayment.toString(): {
      const hasPayment = action.payload.hasPayment;
      const tenantId = Object.keys(store.getState().user.tenantList);
      const startDate = store.getState().booking.desiredDateTime;
      const appointmentType = store.getState().booking.selectedType;
      store.dispatch(searchSuccess({ experts: [] })); // Clear previous search results
      store.dispatch(searchRequest({
        tenantId,
        appointmentType,
        startDate,
        hasPayment,
      }));
      return next(action);
    }

    case check.toString(): {
      const checkedList = store.getState().expert.checkedList;
      if (checkedList.length === MAX_CHECKED_EXPERT_COUNT) {
        store.dispatch(unCheck({ id: checkedList[0] }));
      }
      return next(action);
    }

    default:
      return next(action);
  }
};

export default expertMiddleware;
